import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Util from "@/utils/util.js"
import Ajax from "@/utils/ajax.js"
Vue.prototype.$ajax = Ajax;
Vue.prototype.$util = Util;
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
